"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actionBlock = require("./action-block");

Object.keys(_actionBlock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _actionBlock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _actionBlock[key];
    }
  });
});

var _button = require("./button");

Object.keys(_button).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _button[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _button[key];
    }
  });
});

var _chart = require("./chart");

Object.keys(_chart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _chart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _chart[key];
    }
  });
});

var _chartContainer = require("./chart-container");

Object.keys(_chartContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _chartContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _chartContainer[key];
    }
  });
});

var _chartExtendedContainer = require("./chart-extended-container");

Object.keys(_chartExtendedContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _chartExtendedContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _chartExtendedContainer[key];
    }
  });
});

var _chartSummary = require("./chart-summary");

Object.keys(_chartSummary).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _chartSummary[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _chartSummary[key];
    }
  });
});

var _chartSummaryContainer = require("./chart-summary-container");

Object.keys(_chartSummaryContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _chartSummaryContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _chartSummaryContainer[key];
    }
  });
});

var _checkboxOption = require("./checkbox-option");

Object.keys(_checkboxOption).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkboxOption[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _checkboxOption[key];
    }
  });
});

var _collapse = require("./collapse");

Object.keys(_collapse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _collapse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _collapse[key];
    }
  });
});

var _collapseHead = require("./collapse-head");

Object.keys(_collapseHead).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _collapseHead[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _collapseHead[key];
    }
  });
});

var _colorPicker = require("./color-picker");

Object.keys(_colorPicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _colorPicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _colorPicker[key];
    }
  });
});

var _controlContainer = require("./control-container");

Object.keys(_controlContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _controlContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _controlContainer[key];
    }
  });
});

var _datePicker = require("./date-picker");

Object.keys(_datePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _datePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _datePicker[key];
    }
  });
});

var _dropdown = require("./dropdown");

Object.keys(_dropdown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dropdown[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dropdown[key];
    }
  });
});

var _dropButton = require("./drop-button");

Object.keys(_dropButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dropButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dropButton[key];
    }
  });
});

var _dropdownCore = require("./dropdown-core");

Object.keys(_dropdownCore).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dropdownCore[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dropdownCore[key];
    }
  });
});

var _dropdownIconItem = require("./dropdown-icon-item");

Object.keys(_dropdownIconItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dropdownIconItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dropdownIconItem[key];
    }
  });
});

var _dropdownItem = require("./dropdown-item");

Object.keys(_dropdownItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dropdownItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dropdownItem[key];
    }
  });
});

var _expandButton = require("./expand-button");

Object.keys(_expandButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _expandButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _expandButton[key];
    }
  });
});

var _explanation = require("./explanation");

Object.keys(_explanation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _explanation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _explanation[key];
    }
  });
});

var _fileInput = require("./file-input");

Object.keys(_fileInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fileInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fileInput[key];
    }
  });
});

var _fileItem = require("./file-item");

Object.keys(_fileItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fileItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fileItem[key];
    }
  });
});

var _headedCollapse = require("./headed-collapse");

Object.keys(_headedCollapse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _headedCollapse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _headedCollapse[key];
    }
  });
});

var _helpTip = require("./help-tip");

Object.keys(_helpTip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _helpTip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _helpTip[key];
    }
  });
});

var _helpTipContent = require("./help-tip-content");

Object.keys(_helpTipContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _helpTipContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _helpTipContent[key];
    }
  });
});

var _iconButton = require("./icon-button");

Object.keys(_iconButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _iconButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _iconButton[key];
    }
  });
});

var _input = require("./input");

Object.keys(_input).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _input[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _input[key];
    }
  });
});

var _linkContainer = require("./link-container");

Object.keys(_linkContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _linkContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _linkContainer[key];
    }
  });
});

var _menu = require("./menu");

Object.keys(_menu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _menu[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _menu[key];
    }
  });
});

var _menuItem = require("./menu-item");

Object.keys(_menuItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _menuItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _menuItem[key];
    }
  });
});

var _paginator = require("./paginator");

Object.keys(_paginator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _paginator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _paginator[key];
    }
  });
});

var _plateButton = require("./plate-button");

Object.keys(_plateButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _plateButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _plateButton[key];
    }
  });
});

var _popup = require("./popup");

Object.keys(_popup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _popup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _popup[key];
    }
  });
});

var _progress = require("./progress");

Object.keys(_progress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _progress[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _progress[key];
    }
  });
});

var _radioOption = require("./radio-option");

Object.keys(_radioOption).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _radioOption[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _radioOption[key];
    }
  });
});

var _secondaryButton = require("./secondary-button");

Object.keys(_secondaryButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _secondaryButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _secondaryButton[key];
    }
  });
});

var _select = require("./select");

Object.keys(_select).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _select[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _select[key];
    }
  });
});

var _slider = require("./slider");

Object.keys(_slider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _slider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _slider[key];
    }
  });
});

var _snackbar = require("./snackbar");

Object.keys(_snackbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _snackbar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _snackbar[key];
    }
  });
});

var _spinner = require("./spinner");

Object.keys(_spinner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _spinner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _spinner[key];
    }
  });
});

var _switcherOption = require("./switcher-option");

Object.keys(_switcherOption).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _switcherOption[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _switcherOption[key];
    }
  });
});

var _table = require("./table");

Object.keys(_table).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _table[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _table[key];
    }
  });
});

var _tabs = require("./tabs");

Object.keys(_tabs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tabs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tabs[key];
    }
  });
});

var _tag = require("./tag");

Object.keys(_tag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tag[key];
    }
  });
});

var _tip = require("./tip");

Object.keys(_tip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tip[key];
    }
  });
});

var _toggler = require("./toggler");

Object.keys(_toggler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _toggler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _toggler[key];
    }
  });
});

var _markupTag = require("./markup-tag");

Object.keys(_markupTag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _markupTag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _markupTag[key];
    }
  });
});

var _colorTag = require("./color-tag");

Object.keys(_colorTag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _colorTag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _colorTag[key];
    }
  });
});

var _statusCircle = require("./status-circle");

Object.keys(_statusCircle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _statusCircle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _statusCircle[key];
    }
  });
});

var _statusBar = require("./status-bar");

Object.keys(_statusBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _statusBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _statusBar[key];
    }
  });
});

var _matrixChart = require("./matrix-chart");

Object.keys(_matrixChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _matrixChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _matrixChart[key];
    }
  });
});

var _timePicker = require("./time-picker");

Object.keys(_timePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _timePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _timePicker[key];
    }
  });
});

var _inputCounter = require("./input-counter");

Object.keys(_inputCounter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _inputCounter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _inputCounter[key];
    }
  });
});

var _tooltip = require("./tooltip");

Object.keys(_tooltip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tooltip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tooltip[key];
    }
  });
});

var _SvgChannelApple = require("./svg/channels/SvgChannelApple");

Object.keys(_SvgChannelApple).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelApple[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelApple[key];
    }
  });
});

var _SvgChannelFacebook = require("./svg/channels/SvgChannelFacebook");

Object.keys(_SvgChannelFacebook).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelFacebook[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelFacebook[key];
    }
  });
});

var _SvgChannelOk = require("./svg/channels/SvgChannelOk");

Object.keys(_SvgChannelOk).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelOk[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelOk[key];
    }
  });
});

var _SvgChannelTelegram = require("./svg/channels/SvgChannelTelegram");

Object.keys(_SvgChannelTelegram).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelTelegram[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelTelegram[key];
    }
  });
});

var _SvgChannelFlomni = require("./svg/channels/SvgChannelFlomni");

Object.keys(_SvgChannelFlomni).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelFlomni[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelFlomni[key];
    }
  });
});

var _SvgChannelSms = require("./svg/channels/SvgChannelSms");

Object.keys(_SvgChannelSms).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelSms[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelSms[key];
    }
  });
});

var _SvgChannelViber = require("./svg/channels/SvgChannelViber");

Object.keys(_SvgChannelViber).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelViber[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelViber[key];
    }
  });
});

var _SvgChannelVk = require("./svg/channels/SvgChannelVk");

Object.keys(_SvgChannelVk).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelVk[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelVk[key];
    }
  });
});

var _SvgChannelWhatsApp = require("./svg/channels/SvgChannelWhatsApp");

Object.keys(_SvgChannelWhatsApp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelWhatsApp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelWhatsApp[key];
    }
  });
});

var _SvgChannelWeb = require("./svg/channels/SvgChannelWeb");

Object.keys(_SvgChannelWeb).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelWeb[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelWeb[key];
    }
  });
});

var _SvgChannelEmail = require("./svg/channels/SvgChannelEmail");

Object.keys(_SvgChannelEmail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelEmail[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelEmail[key];
    }
  });
});

var _SvgChannelMobile = require("./svg/channels/SvgChannelMobile");

Object.keys(_SvgChannelMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelMobile[key];
    }
  });
});

var _SvgChannelVoicer = require("./svg/channels/SvgChannelVoicer");

Object.keys(_SvgChannelVoicer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgChannelVoicer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgChannelVoicer[key];
    }
  });
});

var _SvgBtAlignItems = require("./svg/icons/SvgBtAlignItems");

Object.keys(_SvgBtAlignItems).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtAlignItems[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtAlignItems[key];
    }
  });
});

var _SvgBtArrowLeft = require("./svg/icons/SvgBtArrowLeft");

Object.keys(_SvgBtArrowLeft).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtArrowLeft[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtArrowLeft[key];
    }
  });
});

var _SvgBtArrowRight = require("./svg/icons/SvgBtArrowRight");

Object.keys(_SvgBtArrowRight).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtArrowRight[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtArrowRight[key];
    }
  });
});

var _SvgBtCalendar = require("./svg/icons/SvgBtCalendar");

Object.keys(_SvgBtCalendar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtCalendar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtCalendar[key];
    }
  });
});

var _SvgBtChart = require("./svg/icons/SvgBtChart");

Object.keys(_SvgBtChart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtChart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtChart[key];
    }
  });
});

var _SvgBtChat = require("./svg/icons/SvgBtChat");

Object.keys(_SvgBtChat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtChat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtChat[key];
    }
  });
});

var _SvgBtClock = require("./svg/icons/SvgBtClock");

Object.keys(_SvgBtClock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtClock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtClock[key];
    }
  });
});

var _SvgBtClose = require("./svg/icons/SvgBtClose");

Object.keys(_SvgBtClose).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtClose[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtClose[key];
    }
  });
});

var _SvgBtClosedEye = require("./svg/icons/SvgBtClosedEye");

Object.keys(_SvgBtClosedEye).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtClosedEye[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtClosedEye[key];
    }
  });
});

var _SvgBtColItems = require("./svg/icons/SvgBtColItems");

Object.keys(_SvgBtColItems).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtColItems[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtColItems[key];
    }
  });
});

var _SvgBtConversation = require("./svg/icons/SvgBtConversation");

Object.keys(_SvgBtConversation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtConversation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtConversation[key];
    }
  });
});

var _SvgBtCopy = require("./svg/icons/SvgBtCopy");

Object.keys(_SvgBtCopy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtCopy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtCopy[key];
    }
  });
});

var _SvgBtCrown = require("./svg/icons/SvgBtCrown");

Object.keys(_SvgBtCrown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtCrown[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtCrown[key];
    }
  });
});

var _SvgBtCut = require("./svg/icons/SvgBtCut");

Object.keys(_SvgBtCut).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtCut[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtCut[key];
    }
  });
});

var _SvgBtDelete = require("./svg/icons/SvgBtDelete");

Object.keys(_SvgBtDelete).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtDelete[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtDelete[key];
    }
  });
});

var _SvgBtDot = require("./svg/icons/SvgBtDot");

Object.keys(_SvgBtDot).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtDot[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtDot[key];
    }
  });
});

var _SvgBtKeyCommand = require("./svg/icons/SvgBtKeyCommand");

Object.keys(_SvgBtKeyCommand).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtKeyCommand[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtKeyCommand[key];
    }
  });
});

var _SvgBtKeyControl = require("./svg/icons/SvgBtKeyControl");

Object.keys(_SvgBtKeyControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtKeyControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtKeyControl[key];
    }
  });
});

var _SvgBtDoubleLeftChevron = require("./svg/icons/SvgBtDoubleLeftChevron");

Object.keys(_SvgBtDoubleLeftChevron).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtDoubleLeftChevron[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtDoubleLeftChevron[key];
    }
  });
});

var _SvgBtDoubleRightChevron = require("./svg/icons/SvgBtDoubleRightChevron");

Object.keys(_SvgBtDoubleRightChevron).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtDoubleRightChevron[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtDoubleRightChevron[key];
    }
  });
});

var _SvgBtDown = require("./svg/icons/SvgBtDown");

Object.keys(_SvgBtDown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtDown[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtDown[key];
    }
  });
});

var _SvgBtDownload = require("./svg/icons/SvgBtDownload");

Object.keys(_SvgBtDownload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtDownload[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtDownload[key];
    }
  });
});

var _SvgBtDrug = require("./svg/icons/SvgBtDrug");

Object.keys(_SvgBtDrug).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtDrug[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtDrug[key];
    }
  });
});

var _SvgBtExpand = require("./svg/icons/SvgBtExpand");

Object.keys(_SvgBtExpand).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtExpand[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtExpand[key];
    }
  });
});

var _SvgBtCollapse = require("./svg/icons/SvgBtCollapse");

Object.keys(_SvgBtCollapse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtCollapse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtCollapse[key];
    }
  });
});

var _SvgBtEdit = require("./svg/icons/SvgBtEdit");

Object.keys(_SvgBtEdit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtEdit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtEdit[key];
    }
  });
});

var _SvgBtBlock = require("./svg/icons/SvgBtBlock");

Object.keys(_SvgBtBlock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtBlock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtBlock[key];
    }
  });
});

var _SvgBtUnblock = require("./svg/icons/SvgBtUnblock");

Object.keys(_SvgBtUnblock).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtUnblock[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtUnblock[key];
    }
  });
});

var _SvgBtFullScreen = require("./svg/icons/SvgBtFullScreen");

Object.keys(_SvgBtFullScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtFullScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtFullScreen[key];
    }
  });
});

var _SvgBtLeftChevron = require("./svg/icons/SvgBtLeftChevron");

Object.keys(_SvgBtLeftChevron).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtLeftChevron[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtLeftChevron[key];
    }
  });
});

var _SvgBtMenu = require("./svg/icons/SvgBtMenu");

Object.keys(_SvgBtMenu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtMenu[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtMenu[key];
    }
  });
});

var _SvgBtMinus = require("./svg/icons/SvgBtMinus");

Object.keys(_SvgBtMinus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtMinus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtMinus[key];
    }
  });
});

var _SvgBtMoveDown = require("./svg/icons/SvgBtMoveDown");

Object.keys(_SvgBtMoveDown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtMoveDown[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtMoveDown[key];
    }
  });
});

var _SvgBtMoveUp = require("./svg/icons/SvgBtMoveUp");

Object.keys(_SvgBtMoveUp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtMoveUp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtMoveUp[key];
    }
  });
});

var _SvgBtOpenedEye = require("./svg/icons/SvgBtOpenedEye");

Object.keys(_SvgBtOpenedEye).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtOpenedEye[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtOpenedEye[key];
    }
  });
});

var _SvgBtPaste = require("./svg/icons/SvgBtPaste");

Object.keys(_SvgBtPaste).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtPaste[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtPaste[key];
    }
  });
});

var _SvgBtPlus = require("./svg/icons/SvgBtPlus");

Object.keys(_SvgBtPlus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtPlus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtPlus[key];
    }
  });
});

var _SvgBtPrint = require("./svg/icons/SvgBtPrint");

Object.keys(_SvgBtPrint).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtPrint[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtPrint[key];
    }
  });
});

var _SvgBtLink = require("./svg/icons/SvgBtLink");

Object.keys(_SvgBtLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtLink[key];
    }
  });
});

var _SvgBtPuzzle = require("./svg/icons/SvgBtPuzzle");

Object.keys(_SvgBtPuzzle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtPuzzle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtPuzzle[key];
    }
  });
});

var _SvgBtRefrash = require("./svg/icons/SvgBtRefrash");

Object.keys(_SvgBtRefrash).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtRefrash[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtRefrash[key];
    }
  });
});

var _SvgBtRightChevron = require("./svg/icons/SvgBtRightChevron");

Object.keys(_SvgBtRightChevron).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtRightChevron[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtRightChevron[key];
    }
  });
});

var _SvgBtSchedule = require("./svg/icons/SvgBtSchedule");

Object.keys(_SvgBtSchedule).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtSchedule[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtSchedule[key];
    }
  });
});

var _SvgBtSearch = require("./svg/icons/SvgBtSearch");

Object.keys(_SvgBtSearch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtSearch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtSearch[key];
    }
  });
});

var _SvgBtSmallScreen = require("./svg/icons/SvgBtSmallScreen");

Object.keys(_SvgBtSmallScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtSmallScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtSmallScreen[key];
    }
  });
});

var _SvgBtTable = require("./svg/icons/SvgBtTable");

Object.keys(_SvgBtTable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtTable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtTable[key];
    }
  });
});

var _SvgBtUndo = require("./svg/icons/SvgBtUndo");

Object.keys(_SvgBtUndo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtUndo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtUndo[key];
    }
  });
});

var _SvgBtUndoFw = require("./svg/icons/SvgBtUndoFw");

Object.keys(_SvgBtUndoFw).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtUndoFw[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtUndoFw[key];
    }
  });
});

var _SvgBtUpload = require("./svg/icons/SvgBtUpload");

Object.keys(_SvgBtUpload).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtUpload[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtUpload[key];
    }
  });
});

var _SvgBtVariables = require("./svg/icons/SvgBtVariables");

Object.keys(_SvgBtVariables).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtVariables[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtVariables[key];
    }
  });
});

var _SvgBtVersion = require("./svg/icons/SvgBtVersion");

Object.keys(_SvgBtVersion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtVersion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtVersion[key];
    }
  });
});

var _SvgBtPhoneNumbers = require("./svg/icons/SvgBtPhoneNumbers");

Object.keys(_SvgBtPhoneNumbers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtPhoneNumbers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtPhoneNumbers[key];
    }
  });
});

var _SvgBtMessage = require("./svg/icons/SvgBtMessage");

Object.keys(_SvgBtMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtMessage[key];
    }
  });
});

var _SvgBtMessageId = require("./svg/icons/SvgBtMessageId");

Object.keys(_SvgBtMessageId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtMessageId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtMessageId[key];
    }
  });
});

var _SvgBtUserId = require("./svg/icons/SvgBtUserId");

Object.keys(_SvgBtUserId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtUserId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtUserId[key];
    }
  });
});

var _SvgBtExternalLink = require("./svg/icons/SvgBtExternalLink");

Object.keys(_SvgBtExternalLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtExternalLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtExternalLink[key];
    }
  });
});

var _SvgBtUp = require("./svg/icons/SvgBtUp");

Object.keys(_SvgBtUp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtUp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtUp[key];
    }
  });
});

var _SvgBtUnion = require("./svg/icons/SvgBtUnion");

Object.keys(_SvgBtUnion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgBtUnion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgBtUnion[key];
    }
  });
});

var _SvgInClose = require("./svg/interface/SvgInClose");

Object.keys(_SvgInClose).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInClose[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInClose[key];
    }
  });
});

var _SvgInCloseThin = require("./svg/interface/SvgInCloseThin");

Object.keys(_SvgInCloseThin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInCloseThin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInCloseThin[key];
    }
  });
});

var _SvgInDevelopmentCap = require("./svg/interface/SvgInDevelopmentCap");

Object.keys(_SvgInDevelopmentCap).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInDevelopmentCap[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInDevelopmentCap[key];
    }
  });
});

var _SvgInEmptyCap = require("./svg/interface/SvgInEmptyCap");

Object.keys(_SvgInEmptyCap).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInEmptyCap[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInEmptyCap[key];
    }
  });
});

var _SvgInLamp = require("./svg/interface/SvgInLamp");

Object.keys(_SvgInLamp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInLamp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInLamp[key];
    }
  });
});

var _SvgInLinkArrowLeft = require("./svg/interface/SvgInLinkArrowLeft");

Object.keys(_SvgInLinkArrowLeft).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInLinkArrowLeft[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInLinkArrowLeft[key];
    }
  });
});

var _SvgInLinkArrowRight = require("./svg/interface/SvgInLinkArrowRight");

Object.keys(_SvgInLinkArrowRight).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInLinkArrowRight[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInLinkArrowRight[key];
    }
  });
});

var _SvgInPlusFat = require("./svg/interface/SvgInPlusFat");

Object.keys(_SvgInPlusFat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInPlusFat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInPlusFat[key];
    }
  });
});

var _SvgInSelectArrow = require("./svg/interface/SvgInSelectArrow");

Object.keys(_SvgInSelectArrow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInSelectArrow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInSelectArrow[key];
    }
  });
});

var _SvgInSearch = require("./svg/interface/SvgInSearch");

Object.keys(_SvgInSearch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInSearch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInSearch[key];
    }
  });
});

var _SvgInTickBlue = require("./svg/interface/SvgInTickBlue");

Object.keys(_SvgInTickBlue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInTickBlue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInTickBlue[key];
    }
  });
});

var _SvgInGoalFail = require("./svg/interface/SvgInGoalFail");

Object.keys(_SvgInGoalFail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInGoalFail[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInGoalFail[key];
    }
  });
});

var _SvgInGoalSuccess = require("./svg/interface/SvgInGoalSuccess");

Object.keys(_SvgInGoalSuccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInGoalSuccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInGoalSuccess[key];
    }
  });
});

var _SvgInWarning = require("./svg/interface/SvgInWarning");

Object.keys(_SvgInWarning).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgInWarning[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgInWarning[key];
    }
  });
});

var _SvgIconAlertCircle = require("./svg/feathers/SvgIconAlertCircle");

Object.keys(_SvgIconAlertCircle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconAlertCircle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconAlertCircle[key];
    }
  });
});

var _SvgIconAlertTriangle = require("./svg/feathers/SvgIconAlertTriangle");

Object.keys(_SvgIconAlertTriangle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconAlertTriangle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconAlertTriangle[key];
    }
  });
});

var _SvgIconArrowDownChevron = require("./svg/feathers/SvgIconArrowDownChevron");

Object.keys(_SvgIconArrowDownChevron).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArrowDownChevron[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArrowDownChevron[key];
    }
  });
});

var _SvgIconArrowDownChevronSmall = require("./svg/feathers/SvgIconArrowDownChevronSmall");

Object.keys(_SvgIconArrowDownChevronSmall).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArrowDownChevronSmall[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArrowDownChevronSmall[key];
    }
  });
});

var _SvgIconArrowDown = require("./svg/feathers/SvgIconArrowDown");

Object.keys(_SvgIconArrowDown).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArrowDown[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArrowDown[key];
    }
  });
});

var _SvgIconArrowRightChevron = require("./svg/feathers/SvgIconArrowRightChevron");

Object.keys(_SvgIconArrowRightChevron).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArrowRightChevron[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArrowRightChevron[key];
    }
  });
});

var _SvgIconArrowRightCircle = require("./svg/feathers/SvgIconArrowRightCircle");

Object.keys(_SvgIconArrowRightCircle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArrowRightCircle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArrowRightCircle[key];
    }
  });
});

var _SvgIconArrowRightFilled = require("./svg/feathers/SvgIconArrowRightFilled");

Object.keys(_SvgIconArrowRightFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArrowRightFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArrowRightFilled[key];
    }
  });
});

var _SvgIconArrowRight = require("./svg/feathers/SvgIconArrowRight");

Object.keys(_SvgIconArrowRight).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArrowRight[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArrowRight[key];
    }
  });
});

var _SvgIconArrowLeft = require("./svg/feathers/SvgIconArrowLeft");

Object.keys(_SvgIconArrowLeft).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArrowLeft[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArrowLeft[key];
    }
  });
});

var _SvgIconAttach = require("./svg/feathers/SvgIconAttach");

Object.keys(_SvgIconAttach).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconAttach[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconAttach[key];
    }
  });
});

var _SvgIconBackCircle = require("./svg/feathers/SvgIconBackCircle");

Object.keys(_SvgIconBackCircle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconBackCircle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconBackCircle[key];
    }
  });
});

var _SvgIconBack = require("./svg/feathers/SvgIconBack");

Object.keys(_SvgIconBack).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconBack[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconBack[key];
    }
  });
});

var _SvgIconBan = require("./svg/feathers/SvgIconBan");

Object.keys(_SvgIconBan).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconBan[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconBan[key];
    }
  });
});

var _SvgIconSend = require("./svg/feathers/SvgIconSend");

Object.keys(_SvgIconSend).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconSend[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconSend[key];
    }
  });
});

var _SvgIconBookmark = require("./svg/feathers/SvgIconBookmark");

Object.keys(_SvgIconBookmark).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconBookmark[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconBookmark[key];
    }
  });
});

var _SvgIconBookmarkFilled = require("./svg/feathers/SvgIconBookmarkFilled");

Object.keys(_SvgIconBookmarkFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconBookmarkFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconBookmarkFilled[key];
    }
  });
});

var _SvgIconRelatedChats = require("./svg/feathers/SvgIconRelatedChats");

Object.keys(_SvgIconRelatedChats).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconRelatedChats[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconRelatedChats[key];
    }
  });
});

var _SvgIconCalendar = require("./svg/feathers/SvgIconCalendar");

Object.keys(_SvgIconCalendar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconCalendar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconCalendar[key];
    }
  });
});

var _SvgIconChatIdFilled = require("./svg/feathers/SvgIconChatIdFilled");

Object.keys(_SvgIconChatIdFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconChatIdFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconChatIdFilled[key];
    }
  });
});

var _SvgIconClockFilled = require("./svg/feathers/SvgIconClockFilled");

Object.keys(_SvgIconClockFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconClockFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconClockFilled[key];
    }
  });
});

var _SvgIconQueue = require("./svg/feathers/SvgIconQueue");

Object.keys(_SvgIconQueue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconQueue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconQueue[key];
    }
  });
});

var _SvgIconClockStroke = require("./svg/feathers/SvgIconClockStroke");

Object.keys(_SvgIconClockStroke).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconClockStroke[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconClockStroke[key];
    }
  });
});

var _SvgIconClose = require("./svg/feathers/SvgIconClose");

Object.keys(_SvgIconClose).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconClose[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconClose[key];
    }
  });
});

var _SvgIconOpenColumn = require("./svg/feathers/SvgIconOpenColumn");

Object.keys(_SvgIconOpenColumn).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconOpenColumn[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconOpenColumn[key];
    }
  });
});

var _SvgIconCloseColumn = require("./svg/feathers/SvgIconCloseColumn");

Object.keys(_SvgIconCloseColumn).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconCloseColumn[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconCloseColumn[key];
    }
  });
});

var _SvgIconCopy = require("./svg/feathers/SvgIconCopy");

Object.keys(_SvgIconCopy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconCopy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconCopy[key];
    }
  });
});

var _SvgIconCross = require("./svg/feathers/SvgIconCross");

Object.keys(_SvgIconCross).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconCross[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconCross[key];
    }
  });
});

var _SvgIconDelete = require("./svg/feathers/SvgIconDelete");

Object.keys(_SvgIconDelete).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconDelete[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconDelete[key];
    }
  });
});

var _SvgIconDone = require("./svg/feathers/SvgIconDone");

Object.keys(_SvgIconDone).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconDone[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconDone[key];
    }
  });
});

var _SvgIconInQueue = require("./svg/feathers/SvgIconInQueue");

Object.keys(_SvgIconInQueue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconInQueue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconInQueue[key];
    }
  });
});

var _SvgIconNew = require("./svg/feathers/SvgIconNew");

Object.keys(_SvgIconNew).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconNew[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconNew[key];
    }
  });
});

var _SvgIconMy = require("./svg/feathers/SvgIconMy");

Object.keys(_SvgIconMy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconMy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconMy[key];
    }
  });
});

var _SvgIconBot = require("./svg/feathers/SvgIconBot");

Object.keys(_SvgIconBot).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconBot[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconBot[key];
    }
  });
});

var _SvgIconAgent = require("./svg/feathers/SvgIconAgent");

Object.keys(_SvgIconAgent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconAgent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconAgent[key];
    }
  });
});

var _SvgIconDownAndUpArrowsChevron = require("./svg/feathers/SvgIconDownAndUpArrowsChevron");

Object.keys(_SvgIconDownAndUpArrowsChevron).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconDownAndUpArrowsChevron[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconDownAndUpArrowsChevron[key];
    }
  });
});

var _SvgIconDownArrowsTwo = require("./svg/feathers/SvgIconDownArrowsTwo");

Object.keys(_SvgIconDownArrowsTwo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconDownArrowsTwo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconDownArrowsTwo[key];
    }
  });
});

var _SvgIconDownCirlce = require("./svg/feathers/SvgIconDownCirlce");

Object.keys(_SvgIconDownCirlce).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconDownCirlce[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconDownCirlce[key];
    }
  });
});

var _SvgIconDownFilled = require("./svg/feathers/SvgIconDownFilled");

Object.keys(_SvgIconDownFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconDownFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconDownFilled[key];
    }
  });
});

var _SvgIconDrug = require("./svg/feathers/SvgIconDrug");

Object.keys(_SvgIconDrug).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconDrug[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconDrug[key];
    }
  });
});

var _SvgIconEdit = require("./svg/feathers/SvgIconEdit");

Object.keys(_SvgIconEdit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconEdit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconEdit[key];
    }
  });
});

var _SvgIconExportArrow = require("./svg/feathers/SvgIconExportArrow");

Object.keys(_SvgIconExportArrow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconExportArrow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconExportArrow[key];
    }
  });
});

var _SvgIconExternalLink = require("./svg/feathers/SvgIconExternalLink");

Object.keys(_SvgIconExternalLink).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconExternalLink[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconExternalLink[key];
    }
  });
});

var _SvgIconFilter = require("./svg/feathers/SvgIconFilter");

Object.keys(_SvgIconFilter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconFilter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconFilter[key];
    }
  });
});

var _SvgIconHeartFilled = require("./svg/feathers/SvgIconHeartFilled");

Object.keys(_SvgIconHeartFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconHeartFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconHeartFilled[key];
    }
  });
});

var _SvgIconForward = require("./svg/feathers/SvgIconForward");

Object.keys(_SvgIconForward).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconForward[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconForward[key];
    }
  });
});

var _SvgIconHeartStroke = require("./svg/feathers/SvgIconHeartStroke");

Object.keys(_SvgIconHeartStroke).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconHeartStroke[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconHeartStroke[key];
    }
  });
});

var _SvgIconButtonsFilled = require("./svg/feathers/SvgIconButtonsFilled");

Object.keys(_SvgIconButtonsFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconButtonsFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconButtonsFilled[key];
    }
  });
});

var _SvgIconButtonsStroke = require("./svg/feathers/SvgIconButtonsStroke");

Object.keys(_SvgIconButtonsStroke).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconButtonsStroke[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconButtonsStroke[key];
    }
  });
});

var _SvgIconHide = require("./svg/feathers/SvgIconHide");

Object.keys(_SvgIconHide).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconHide[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconHide[key];
    }
  });
});

var _SvgIconInfo = require("./svg/feathers/SvgIconInfo");

Object.keys(_SvgIconInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconInfo[key];
    }
  });
});

var _SvgIconKeyCommandSmall = require("./svg/feathers/SvgIconKeyCommandSmall");

Object.keys(_SvgIconKeyCommandSmall).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconKeyCommandSmall[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconKeyCommandSmall[key];
    }
  });
});

var _SvgIconKeyLetterSmall = require("./svg/feathers/SvgIconKeyLetterSmall");

Object.keys(_SvgIconKeyLetterSmall).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconKeyLetterSmall[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconKeyLetterSmall[key];
    }
  });
});

var _SvgIconLightiningFilled = require("./svg/feathers/SvgIconLightiningFilled");

Object.keys(_SvgIconLightiningFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconLightiningFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconLightiningFilled[key];
    }
  });
});

var _SvgIconLightiningStroke = require("./svg/feathers/SvgIconLightiningStroke");

Object.keys(_SvgIconLightiningStroke).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconLightiningStroke[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconLightiningStroke[key];
    }
  });
});

var _SvgIconLocation = require("./svg/feathers/SvgIconLocation");

Object.keys(_SvgIconLocation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconLocation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconLocation[key];
    }
  });
});

var _SvgIconMail = require("./svg/feathers/SvgIconMail");

Object.keys(_SvgIconMail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconMail[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconMail[key];
    }
  });
});

var _SvgIconMenuBurger = require("./svg/feathers/SvgIconMenuBurger");

Object.keys(_SvgIconMenuBurger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconMenuBurger[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconMenuBurger[key];
    }
  });
});

var _SvgIconMenuDots = require("./svg/feathers/SvgIconMenuDots");

Object.keys(_SvgIconMenuDots).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconMenuDots[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconMenuDots[key];
    }
  });
});

var _SvgIconMoney = require("./svg/feathers/SvgIconMoney");

Object.keys(_SvgIconMoney).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconMoney[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconMoney[key];
    }
  });
});

var _SvgIconPin = require("./svg/feathers/SvgIconPin");

Object.keys(_SvgIconPin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconPin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconPin[key];
    }
  });
});

var _SvgIconPlus = require("./svg/feathers/SvgIconPlus");

Object.keys(_SvgIconPlus).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconPlus[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconPlus[key];
    }
  });
});

var _SvgIconProcess = require("./svg/feathers/SvgIconProcess");

Object.keys(_SvgIconProcess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconProcess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconProcess[key];
    }
  });
});

var _SvgIconQuestion = require("./svg/feathers/SvgIconQuestion");

Object.keys(_SvgIconQuestion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconQuestion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconQuestion[key];
    }
  });
});

var _SvgIconQuestionStroke = require("./svg/feathers/SvgIconQuestionStroke");

Object.keys(_SvgIconQuestionStroke).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconQuestionStroke[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconQuestionStroke[key];
    }
  });
});

var _SvgIconRefresh = require("./svg/feathers/SvgIconRefresh");

Object.keys(_SvgIconRefresh).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconRefresh[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconRefresh[key];
    }
  });
});

var _SvgIconResend = require("./svg/feathers/SvgIconResend");

Object.keys(_SvgIconResend).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconResend[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconResend[key];
    }
  });
});

var _SvgIconSearch = require("./svg/feathers/SvgIconSearch");

Object.keys(_SvgIconSearch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconSearch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconSearch[key];
    }
  });
});

var _SvgIconSettings = require("./svg/feathers/SvgIconSettings");

Object.keys(_SvgIconSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconSettings[key];
    }
  });
});

var _SvgIconShareable = require("./svg/feathers/SvgIconShareable");

Object.keys(_SvgIconShareable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconShareable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconShareable[key];
    }
  });
});

var _SvgIconSheet = require("./svg/feathers/SvgIconSheet");

Object.keys(_SvgIconSheet).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconSheet[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconSheet[key];
    }
  });
});

var _SvgIconShow = require("./svg/feathers/SvgIconShow");

Object.keys(_SvgIconShow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconShow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconShow[key];
    }
  });
});

var _SvgIconSmile = require("./svg/feathers/SvgIconSmile");

Object.keys(_SvgIconSmile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconSmile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconSmile[key];
    }
  });
});

var _SvgIconStarFilled = require("./svg/feathers/SvgIconStarFilled");

Object.keys(_SvgIconStarFilled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconStarFilled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconStarFilled[key];
    }
  });
});

var _SvgIconStarStroke = require("./svg/feathers/SvgIconStarStroke");

Object.keys(_SvgIconStarStroke).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconStarStroke[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconStarStroke[key];
    }
  });
});

var _SvgIconStopWatch = require("./svg/feathers/SvgIconStopWatch");

Object.keys(_SvgIconStopWatch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconStopWatch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconStopWatch[key];
    }
  });
});

var _SvgIconTag = require("./svg/feathers/SvgIconTag");

Object.keys(_SvgIconTag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconTag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconTag[key];
    }
  });
});

var _SvgIconEvents = require("./svg/feathers/SvgIconEvents");

Object.keys(_SvgIconEvents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconEvents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconEvents[key];
    }
  });
});

var _SvgIconReminder = require("./svg/feathers/SvgIconReminder");

Object.keys(_SvgIconReminder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconReminder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconReminder[key];
    }
  });
});

var _SvgIconArchive = require("./svg/feathers/SvgIconArchive");

Object.keys(_SvgIconArchive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconArchive[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconArchive[key];
    }
  });
});

var _SvgIconThread = require("./svg/feathers/SvgIconThread");

Object.keys(_SvgIconThread).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconThread[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconThread[key];
    }
  });
});

var _SvgIconTickCircle = require("./svg/feathers/SvgIconTickCircle");

Object.keys(_SvgIconTickCircle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconTickCircle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconTickCircle[key];
    }
  });
});

var _SvgIconTick = require("./svg/feathers/SvgIconTick");

Object.keys(_SvgIconTick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconTick[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconTick[key];
    }
  });
});

var _SvgIconUnpin = require("./svg/feathers/SvgIconUnpin");

Object.keys(_SvgIconUnpin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconUnpin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconUnpin[key];
    }
  });
});

var _SvgIconUser = require("./svg/feathers/SvgIconUser");

Object.keys(_SvgIconUser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SvgIconUser[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SvgIconUser[key];
    }
  });
});